module.exports = __webpack_public_path__ + "img/wifi.21c01143.svg";